import serverInterface from 'server-interface';
import IconButton from 'generics/components/icon-button';

class DeleteSigneeButton {

  constructor(configuration) {

    this.signee = configuration.signee;
    this.onDelete = configuration.onDelete;
    this.button = IconButton.deleteButtonSmall({
      onClick: this.deleteSignee.bind(this)
    });
    this.el = this.button.el;

  }

  async deleteSignee() {

    await serverInterface.startup.signaturePanel.deleteSignee(this.signee.panelId, this.signee.startupUserId);

    this.onDelete();

  }

}

export default DeleteSigneeButton;